import React, { useEffect } from 'react';
import Select from 'react-select';
import { Tooltip } from './Tooltip';

const DropDown = ({
    field = '',
    label = '',
    valueSelect = '',
    placeholder = '',
    dataProvider = [],
    isRequired = true,
    containBlank = true,
    className = '',
    useDesc = false,
    useTooltip = false,
    titleTooltip = '',
    textTooltip = '',
    onChangeSelect = () => ''
}) => {

    const sinAsignar = [{ value: '', text: 'Seleccione' }];

    const changeHandler = (e) => {
        let event = { target: {} };
        event.target.value = e.value;
        event.target.name = field;
        event.target.desc = e.text;
        if (e.value)
            onChangeSelect(event);
    }



    const customStyles = {
        option: (provided, state) => {
            return {
                ...provided,
                fontSize: '13px',
                padding: '4px 12px',
                backgroundColor: state.isSelected ? "#F8B31F" : "white",

            }
        },
        input: (provided, state) => {
            return {
                ...provided,
                width: "100%",
            }
        },
        dropdownIndicator: (provided, state) => {
            return {
                ...provided,
                color: "#F8B31F",
                '&:hover': {
                    "outline-style": "none !important",
                    color: "#F8B31F",
                },

            }
        },
        indicatorsContainer: (provided, state) => {
            // console.log(provided);
            // console.log(state);
            return {
                ...provided,
                height: 28,
                padding: 0,
                color: '#F8B31F',

            }
        },
        control: (provided, state) => {
            return {
                ...provided,
                minHeight: 28,
                border: state.isFocused ? "1px solid #BFBFBF" : "1px solid #BFBFBF",
                // height: "30",
                width: "100%",
                fontSize: '13px',
                backgroundColor: '#FFF',
                borderRadius: 5,
                borderColor: state.isFocused && "#BFBFBF",
                boxShadow: state.isFocused ? 0 : 0,
                "text-align-last": "left",
                "outline-style": state.isFocused ? "none" : "none",
                '&:hover': {
                    "outline-style": "none !important",
                    "border-left": "1px solid #F8B31F !important",
                },
                selectProps: {
                    backgroundColor: "#008964",
                }
            }
        },
        menu: (provided, state) => {
            return {
                ...provided,
                borderRadius: 0,
            }
        },
        placeholder: (provided, state) => {
            return {
                ...provided,
                "text-align": "center",
            }
        },
        singleValue: (provided, state) => {
            return {
                ...provided,
                opacity: state.isDisabled ? 0.5 : 1,
                transition: 'opacity 300ms',

            }
        },
    }

    return (
        <div className={className}>

            {!useTooltip &&
                <div className="lbl-input-ca lbl-input-ca-size">
                    <span> {label} </span>
                </div>

            }
            {useTooltip && <div className="lbl-input-ca lbl-input-ca-size">
                <span> {label} </span>
                <Tooltip title={titleTooltip} text={textTooltip} id={`${field}_tooltip`}  />
            </div>
            }
            {
                <Select
                    name={field}
                    options={containBlank ? [...sinAsignar, ...dataProvider] : dataProvider}
                    getOptionLabel={(x) => useDesc ? x.description : x.text}
                    getOptionValue={(x) => x.value}
                    required={isRequired}
                    value={dataProvider.find(x => x.value == valueSelect) != null ? dataProvider.find(x => x.value == valueSelect) : null}
                    placeholder={placeholder}
                    onChange={changeHandler}
                    styles={customStyles}
                />
            }
            <input
                className="input-required"
                value={valueSelect}
                tabIndex={-1}
                autoComplete="off"
                style={{ opacity: 0, height: 0 }}
                required={isRequired}
            />
        </div>
    );
}

export { DropDown };